import { createSlice } from '@reduxjs/toolkit';
import i18n from 'i18n/i18n';
import {
  SearchMenuAuthorityMasterRequest,
  DetailMenuAuthorityMasterRequest,
  UpdateMenuAuthorityMasterRequest,
  DetailMenuAuthorityMasterResponse,
  SearchMenuAuthorityMasterRecord,
  ScreenListResponse,
  SearchMenuAuthorityMasterResponse,
  NumberingResponse,
} from 'api-types/src/types/menu-authority-master';

type MenuAuthorityMasterState = {
  loading: boolean;
  loadingExportExcel: boolean;
  filterInitialSearchData: SearchMenuAuthorityMasterRecord[];
  filterSearchData: SearchMenuAuthorityMasterRecord[];
  sortSelected: string;
  sortDirection: string;
  message: string;
  menuAuthorityDetail: DetailMenuAuthorityMasterResponse | {};
  success: boolean;
  screenList: ScreenListResponse;
  menuAuthorityNumber: NumberingResponse;
};

const initialState: MenuAuthorityMasterState = {
  loading: false,
  loadingExportExcel: false,
  filterInitialSearchData: [],
  filterSearchData: [],
  sortSelected: '',
  sortDirection: '',
  message: '',
  menuAuthorityDetail: {},
  success: false,
  screenList: [],
  menuAuthorityNumber: [],
};

export const menuAuthorityMasterSlice = createSlice({
  name: 'menuAuthorityMaster',
  initialState,
  reducers: {
    filterMenuAuthority: (state, action: { payload: SearchMenuAuthorityMasterRequest }) => {
      state.loading = true;
      state.message = '';
    },
    filterMenuAuthoritySuccess: (state, action: { payload: SearchMenuAuthorityMasterResponse }) => {
      state.loading = false;
      state.filterInitialSearchData = action.payload?.records;
      state.filterSearchData = action.payload?.records;
      if (!action.payload?.total) {
        state.message = i18n.t('message.common.0001');
      }
      state.success = false;
    },
    filterMenuAuthorityFailure: (state) => {
      state.loading = false;
    },
    getDetailMenuAuthority: (state, action: { payload: DetailMenuAuthorityMasterRequest }) => {
      state.loading = true;
    },
    getDetailMenuAuthoritySuccess: (state, action: { payload: DetailMenuAuthorityMasterResponse }) => {
      state.loading = false;
      state.menuAuthorityDetail = action.payload;
    },
    getDetailMenuAuthorityFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    getScreen: (state) => {
      state.loading = true;
    },
    getScreenSuccess: (state, action: { payload: ScreenListResponse }) => {
      state.loading = false;
      state.screenList = action.payload;
    },
    getScreenFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    numbering: (state) => {
      state.loading = true;
    },
    numberingSuccess: (state, action: { payload: NumberingResponse }) => {
      state.loading = false;
      state.menuAuthorityNumber = action.payload;
    },
    numberingFailure: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },
    setLoadingExportExcel: (state, action) => {
      state.loadingExportExcel = action.payload;
    },
    registerMenuAuthority: (state, action: { payload: UpdateMenuAuthorityMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    registerMenuAuthoritySuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    registerMenuAuthorityFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    updateMenuAuthority: (state, action: { payload: UpdateMenuAuthorityMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    updateMenuAuthoritySuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    updateMenuAuthorityFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload?.message;
    },
    deleteMenuAuthority: (state, action: { payload: UpdateMenuAuthorityMasterRequest }) => {
      state.loading = true;
      state.success = false;
    },
    deleteMenuAuthoritySuccess: (state, action) => {
      state.loading = false;
      state.success = true;
      state.message = action.payload?.message;
    },
    deleteMenuAuthorityFailure: (state, action) => {
      state.loading = false;
      state.success = false;
      state.message = action.payload.message;
    },
    cleanDataMenuAuthority: (state) => {
      state.menuAuthorityDetail = [];
    },
    cleanData: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const {
  filterMenuAuthority,
  filterMenuAuthoritySuccess,
  filterMenuAuthorityFailure,
  setLoadingExportExcel,
  getDetailMenuAuthority,
  getDetailMenuAuthoritySuccess,
  getDetailMenuAuthorityFailure,
  getScreen,
  getScreenSuccess,
  getScreenFailure,
  numbering,
  numberingSuccess,
  numberingFailure,
  registerMenuAuthority,
  registerMenuAuthoritySuccess,
  registerMenuAuthorityFailure,
  updateMenuAuthority,
  updateMenuAuthoritySuccess,
  updateMenuAuthorityFailure,
  deleteMenuAuthority,
  deleteMenuAuthoritySuccess,
  deleteMenuAuthorityFailure,
  cleanDataMenuAuthority,
  cleanData,
} = menuAuthorityMasterSlice.actions;

export default menuAuthorityMasterSlice.reducer;
